import { useQuery } from "@tanstack/react-query";

import { getAdherenceItems } from "@/api/diagnostic";
import { diagnosticKeys } from "@/hooks/useDiagnostic";

/**
 * As linhas do drill-down "Aderência ao padrão" (EF-FUNC-011, RF-08).
 *
 * A chave fica debaixo do prefixo do snapshot do Diagnóstico: quem grava uma
 * decisão invalida o snapshot para o tile mudar, e o TanStack casa por prefixo,
 * então as abas são relidas junto e não mostram outro número que o do tile.
 */
export function useAdherenceItems(projectId: string | undefined) {
  return useQuery({
    queryKey: [...diagnosticKeys.snapshot(projectId ?? ""), "adherence-items"] as const,
    queryFn: () => getAdherenceItems(projectId!),
    enabled: !!projectId,
    staleTime: 30_000,
  });
}
